import * as React from "react";

function SvgFreeTimeCoding(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 611 533"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <g transform="translate(-111.631 -112.28)">
        <g id="free_time_coding_svg__coding">
          <g transform="matrix(0 -1.02307 .75316 0 -57.52 809.583)">
            <path
              d="M161.574 478.587l260-254 260 254v83.243l-260-254-260 254v-83.243z"
              fill="#fe9492"
            />
            <clipPath id="free_time_coding_svg___clip1">
              <path d="M161.574 478.587l260-254 260 254v83.243l-260-254-260 254v-83.243z" />
            </clipPath>
            <g clipPath="url(#free_time_coding_svg___clip1)">
              <path
                fill="#fea4a2"
                d="M54.352 56.163h324V378.83h-324z"
                transform="matrix(0 1.32773 -.97744 0 791.322 76.37)"
              />
            </g>
          </g>
          <g transform="matrix(0 -1.02307 -.75316 0 890.782 809.583)">
            <path
              d="M161.574 478.587l260-254 260 254v83.243l-260-254-260 254v-83.243z"
              fill="#fe8d8a"
            />
            <clipPath id="free_time_coding_svg___clip2">
              <path d="M161.574 478.587l260-254 260 254v83.243l-260-254-260 254v-83.243z" />
            </clipPath>
            <g clipPath="url(#free_time_coding_svg___clip2)">
              <path
                fill="#fe7e7b"
                d="M447.685 377.496h326.667v309.333H447.685z"
                transform="matrix(0 -1.32773 -.97744 0 791.322 1182.72)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgFreeTimeCoding;
